import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ConsumerAuthProvider, consumerAccountsEnabled } from "@/context/ConsumerAuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import CompetitionsList from "@/pages/CompetitionsList";
import CompetitionSeoLanding from "@/pages/CompetitionSeoLanding";
import CompetitionDetail from "@/pages/CompetitionDetail";
import OperatorsList from "@/pages/OperatorsList";
import OperatorDetail from "@/pages/OperatorDetail";
import BestValue from "@/pages/BestValue";
import BestOddsForBudget from "@/pages/BestOddsForBudget";
import About from "@/pages/About";
import SignInComingSoon from "@/pages/SignInComingSoon";
import NotFound from "@/pages/NotFound";
import { GuideDetail, GuidesList } from "@/pages/Guides";
import {
  AffiliateDisclosure,
  Contact,
  CookiePolicy,
  DataAccuracy,
  EditorialMethodology,
  HowItWorks,
  HowWeScore,
  PrivacyPolicy,
  ResponsibleParticipation,
  Terms,
} from "@/pages/InfoPages";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminRouteMeta from "@/components/AdminRouteMeta";
import ConsumerAccount, { ConsumerEmailConfirmation } from "@/pages/ConsumerAccount";
import DeleteAccount from "@/pages/DeleteAccount";
import {
  ConsumerForgotPassword,
  ConsumerLogin,
  ConsumerRegister,
  ConsumerResendVerification,
  ConsumerResetPassword,
  ConsumerVerifyEmail,
} from "@/pages/ConsumerAccess";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ConsumerAuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/competitions" element={<CompetitionsList />} />
              <Route path="/uk-competitions" element={<CompetitionSeoLanding variant="overview" />} />
              <Route path="/uk-car-competitions" element={<CompetitionSeoLanding variant="cars" />} />
              <Route path="/competition/:slug" element={<CompetitionDetail />} />
              <Route path="/operators" element={<OperatorsList />} />
              <Route path="/operators/:slug" element={<OperatorDetail />} />
              <Route path="/best-value" element={<BestValue />} />
              <Route path="/best-odds-for-budget" element={<BestOddsForBudget />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/affiliate-disclosure" element={<AffiliateDisclosure />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/how-we-score" element={<HowWeScore />} />
              <Route path="/data-accuracy" element={<DataAccuracy />} />
              <Route path="/editorial-methodology" element={<EditorialMethodology />} />
              <Route path="/responsible-participation" element={<ResponsibleParticipation />} />
              <Route path="/guides" element={<GuidesList />} />
              <Route path="/guides/:slug" element={<GuideDetail />} />
              <Route path="/signin" element={consumerAccountsEnabled() ? <ConsumerLogin /> : <SignInComingSoon />} />
              {consumerAccountsEnabled() && <>
                <Route path="/login" element={<ConsumerLogin />} />
                <Route path="/register" element={<ConsumerRegister />} />
                <Route path="/resend-verification" element={<ConsumerResendVerification />} />
                <Route path="/verify-email" element={<ConsumerVerifyEmail />} />
                <Route path="/forgot-password" element={<ConsumerForgotPassword />} />
                <Route path="/reset-password" element={<ConsumerResetPassword />} />
                <Route path="/account/email" element={<ConsumerEmailConfirmation />} />
                <Route path="/account/*" element={<ConsumerAccount />} />
              </>}
              <Route
                path="/admin/login"
                element={<AdminRouteMeta><AdminLogin /></AdminRouteMeta>}
              />
              <Route
                path="/admin"
                element={<AdminRouteMeta><AdminDashboard /></AdminRouteMeta>}
              />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </ConsumerAuthProvider>
      </AuthProvider>
    </div>
  );
}
